import { useState } from "react";
import { motion } from "framer-motion";
import { Play, X } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const VIDEOS = [
  {
    title: "Our Gaushala in Navi Mumbai",
    titleHi: "हमारी गौशाला — नवी मुंबई",
    thumb: "https://customer-assets.emergentagent.com/job_pure-milk-navi/artifacts/z3wci6lm_WhatsApp%20Image%202026-04-21%20at%209.51.33%20AM.jpeg",
    src: "https://customer-assets.emergentagent.com/job_pure-milk-navi/artifacts/nc0zz85h_vid1.mp4",
  },
  {
    title: "Morning Feed — Hand-Delivered",
    titleHi: "सुबह का आहार — हाथ से",
    thumb: "https://customer-assets.emergentagent.com/job_pure-milk-navi/artifacts/1tbdeqa7_WhatsApp%20Image%202026-04-21%20at%209.51.34%20AM.jpeg",
    src: "https://customer-assets.emergentagent.com/job_pure-milk-navi/artifacts/g55167ps_vid%202.mp4",
  },
  {
    title: "Our GIR Gaumata Farm",
    titleHi: "हमारा गीर गौमाता फार्म",
    thumb: "https://customer-assets.emergentagent.com/job_pure-milk-navi/artifacts/c16efud5_WhatsApp%20Image%202026-04-21%20at%209.51.33%20AM.jpeg",
    src: "https://customer-assets.emergentagent.com/job_pure-milk-navi/artifacts/jmwdpn85_WhatsApp%20Video%202026-04-21%20at%209.38.54%20AM.mp4",
  },
];

export default function SeeTheDifference() {
  const { lang, t } = useI18n();
  const [active, setActive] = useState(null);

  return (
    <section className="dd-section bg-dd-ivory" data-testid="see-the-difference">
      <div className="dd-container">
        <div className="text-center mb-12 max-w-2xl mx-auto">
          <div className="dd-label text-dd-gold">{t.diff.eyebrow}</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-dd-ink mt-3">{t.diff.title}</h2>
          <div className="dd-ornament my-5"><span className="text-lg">✦</span></div>
          <p className="text-dd-ink-muted">{lang === "hi" ? "हमारी गौशाला की असली झलक — कोई स्टॉक फ़ुटेज नहीं।" : "Real footage from our gaushala — no stock, no actors."}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {VIDEOS.map((v, idx) => (
            <motion.button
              key={idx}
              onClick={() => setActive(v)}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
              className="text-left group relative rounded-xl overflow-hidden border border-dd-line bg-white hover:border-dd-gold hover:shadow-xl transition-all"
              data-testid={`see-diff-${idx}`}
            >
              <div className="aspect-video relative">
                <img src={v.thumb} alt={v.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-dd-ink/50 to-transparent" />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="w-16 h-16 rounded-full bg-dd-orange text-white flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                    <Play className="w-6 h-6 ml-1" fill="currentColor" strokeWidth={0} />
                  </span>
                </span>
                <div className="absolute top-3 left-3 bg-white/95 text-dd-orange px-2 py-0.5 rounded-full text-[0.6rem] font-bold tracking-wider">
                  REAL FARM FOOTAGE
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-serif text-xl text-dd-ink leading-snug">{lang === "hi" ? v.titleHi : v.title}</h3>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      {active && (
        <div className="fixed inset-0 z-50 bg-black/85 flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <div className="relative w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setActive(null)} className="absolute -top-10 right-0 text-white text-sm flex items-center gap-1 hover:text-dd-gold">
              <X className="w-4 h-4" /> Close
            </button>
            <video src={active.src} controls autoPlay playsInline className="w-full aspect-video rounded-lg bg-black" />
          </div>
        </div>
      )}
    </section>
  );
}
